
export const calculateAndFormatTimeRange = (type, time, data) => {
    const calculatedTime = new Date(
      Math[type](...data.map(schedule => new Date(`2000-01-01T${schedule[time]}:00`)))
    );
  
    const minimumTime = new Date('2000-01-01T08:00:00');
    const maximumTime = new Date('2000-01-01T18:00:00');
  
    if (type === 'min' && calculatedTime >= minimumTime) {
      return minimumTime.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' });
    } else if (type === 'max' && calculatedTime <= maximumTime) {
      return maximumTime.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' });
    }
  
    return calculatedTime.toLocaleTimeString('sv-SE', { hour: '2-digit', minute: '2-digit' });
  };
  